export const DONATE_URL = 'https://charity.pledgeit.org/TWWSF2026';
export const FISCAL_SPONSOR_URL = 'https://www.powerofonefoundation.org/';
